export default function isCyclic(object: object) {
  const visitedSet = new Set();
  const stack: string[] = [];

  function detect(obj: unknown, keyStr: string) {
    stack.push(keyStr);

    if (obj === null) return false;

    if (typeof obj === "object") {
      if (visitedSet.has(obj)) {
        return true;
      }

      visitedSet.add(obj);

      for (const key in obj) {
        const nextObj = obj[key as keyof typeof obj];
        if (detect(nextObj, key)) return true;
      }

      for (const sym of Object.getOwnPropertySymbols(obj)) {
        const nextObj = obj[sym as keyof typeof obj];
        if (detect(nextObj, String(sym))) return true;
      }
    }

    stack.pop();

    visitedSet.delete(obj);

    return false;
  }

  if (detect(object, "MODEL")) {
    const stackTrace = stack.join("-> ");

    return stackTrace;
  }

  return false;
}
